import { render, staticRenderFns } from "./SchoolFacialDevicePageTable.vue?vue&type=template&id=090fc108&scoped=true&"
import script from "./SchoolFacialDevicePageTable.vue?vue&type=script&lang=js&"
export * from "./SchoolFacialDevicePageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090fc108",
  null
  
)

export default component.exports